enum PledgeCoveredFee {
    All = 'all',
    OnlyProcessing = 'processing',
    OnlyPlatform = 'platform',
}

enum PledgeCoveredFeePolicy {
    AskToCoverFees = 'optional',
    RequireFees = 'required',
    HideFees = 'hidden',
}

export { PledgeCoveredFeePolicy, PledgeCoveredFee };
